<template lang='pug'>
  .fp-loader.fp-loader-container(:class='{ "with-text": text }')
    .fp-loader-forepaas.loader
      img(src='~@/assets/loader.gif')
    span.fp-loader-text(v-if='text') {{ text }}
</template>

<script>

export default {
  props: {
    text: { type: String }
  }
}
</script>

<style lang='less'>
  .fp-loader-container {
    position:absolute;
    left:0;
    top:0;
    right:0;
    bottom:0;
    background-color: rgba(0, 0, 0, 0.1);
    z-index: 99999999999;
    .loader {
      top: 50%;
      left: 50%;
      position:absolute;
      background-color:rgba(0, 0, 0, 0.1);
      padding: 20px;
      border-radius: 100px;
      width: 120px;
      height: 120px;
      margin-left:-60px;
      margin-top:-60px;
      img {
        position: relative;
        width:40px;
        margin-top:-20px;
        margin-left:-20px;
        top: 50%;
        left: 50%;
      }
    }
    &.with-text {
      .loader {
        top: 45% !important;
      }
      .fp-loader-text {
        position: absolute;
        top: 80%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: white;
        font-size: 18px;
        text-align: center;
        z-index: 2147483647;
      }
    }
  }
</style>
